<template>
  <img alt="Logo" @click="goToWebsite()" class="cursor-pointer" src="@/assets/logo.png" />
</template>
<script>
export default {
  name: 'LogoComponent',
  methods: {
    goToWebsite() {
      window.open('https://www.xtrapension.com/', '_blank');
    }
  }
};
</script>
